// ─── Yonder Lead Capture Service ───────────────────────────────────────────────
// POSTs to the production worker's lead-capture endpoint:
//   POST /api/lead  { email, brand, dna, destination } → { ok: true }
//
// In local dev (no worker running) this fetch will fail or 404 — callers must
// treat that as non-fatal and proceed with the demo flow regardless.

export interface LeadPayload {
  email: string
  brand: 'yonder'
  dna: string
  destination: string
}

export interface LeadResult {
  ok: boolean
}

export async function submitLead(payload: LeadPayload): Promise<LeadResult> {
  try {
    const res = await fetch('/api/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!res.ok) return { ok: false }
    const data = await res.json().catch(() => ({ ok: false }))
    return { ok: !!data?.ok }
  } catch {
    // No worker in dev, network error, etc — never block the demo.
    return { ok: false }
  }
}
